import { Button } from "@mui/material";
import React from "react";
import { Link as ReactRouterLink } from "react-router-dom";

interface Props {
  href: string;
  disabled?: boolean;
  children: React.ReactNode;
}

export function LinkButton({ href, disabled, children }: Props) {
  return (
    <Button LinkComponent={Link} href={href} disabled={disabled}>
      {children}
    </Button>
  );
}

const Link = React.forwardRef<HTMLAnchorElement, { href: string }>(function Link({ href, ...props }, ref) {
  return <ReactRouterLink {...props} ref={ref} to={href} />;
});
